export const NOTES_GET = 'NOTES_GET';
export const NOTE_ADD = 'NOTE_ADD';
export const NOTE_GET = 'NOTE_GET';
export const NOTE_EDIT = 'NOTE_EDIT';
export const NOTE_UPLOADFILE = 'NOTE_UPLOADFILE';
export const NOTE_DELETE = 'NOTE_DELETE';
export const NOTE_RESET_SEARCH = 'NOTE_RESET_SEARCH';
